<template>
    <form name="pay_form" id="pay_form" method="POST">
        <ul class="subject_list" v-if="subjectList.length > 0">
            <li :class="selectedSubjectId == 'ALL' ? 'active' : ''"><a href="javascript:void(0);" @click="selectSubject('ALL')">전체</a></li>
            <li v-for="row in subjectList" :class="selectedSubjectId == row.subject_id ? 'active' : ''" :style="row.show == 'Y' ? 'display:block;' : 'display:none;'"><a href="javascript:void(0);" @click="selectSubject(row.subject_id)">{{row.subject_nm}}</a></li>
        </ul>
        <loading :active.sync="isLoading" :can-cancel="true"></loading>

        <!-- lecture_view::get_staca_academy_total_lecture_html Style -->
        <ul class="lecture_list" v-if="output == 'total'">
            <li v-for="row in lectureList" :id="'saleinfo_' + row.saleinfo_id">
                <h4 class="lec_step">
                    <strong v-if="row.hasOwnProperty('level_nm')">{{row.level_nm}}</strong>
                    <strong v-else-if="row.com_cls_id == '17'">연계</strong>
                </h4>
                <div class="lec_section_title">
                    <p>
                        <a href="javascript:void(0);" v-if="row.com_cls_id == '17'"><template v-if="row.hasOwnProperty('level_nm')">[{{row.level_nm}}]</template>{{row.sale_name}}</a>
                        <a :href="detailLink(row)" @click="afterPreCheck(row)" v-else><template v-if="row.hasOwnProperty('level_nm')">[{{row.level_nm}}]</template>{{row.sale_name}}</a>
                    </p>
                    <div class="wrap_info_lecture">
                        <span>개강일 : <strong>{{row.period_text}}</strong></span>
                        <ul class="medal_list">
                            <li v-for="imgRow in row.sale_icon_list"><img :src="imgRow"/></li>
                        </ul>
                    </div>
                    <div class="discount_area">
                        <div v-if="row.amt_list[0].sale_dis_rate > 0">
                            <span class="txt_original_price"><vue-numeric v-model="row.amt_list[0].sale_amt" read-only></vue-numeric>원</span>
                            <strong><vue-numeric v-model="row.amt_list[0].display_sale_amt" read-only></vue-numeric>원</strong>
                            <span class="txt_discount">{{row.amt_list[0].sale_dis_rate}}%할인</span>
                        </div>
                    </div>
                </div>
                <div class="lec_section_subscript">
                    <div class="btn_list">
                        <div>
                            <span style="color:red;font-weight: bold;">{{row.begin_text}}</span>
                            <img v-for="imgRow in row.close_icon_list" :src="imgRow"/>
                        </div>
                        <div>
                            <span>종료기간 : {{row.cole_edt}}</span>
                        </div>
                        <div>
                            수강료 : <span style="color:red;font-weight: bold;" v-if="row.amt_list[0].sale_dis_rate > 0">{{row.amt_list[0].sale_dis_rate}}% 할인 </span>
                            <vue-numeric v-model="row.amt_list[0].display_sale_amt" read-only></vue-numeric>원
                        </div>
                        <br />
                        <a href="javascript:alert('마감되었습니다.');void(0);" v-if="row.sale_limit_status === 'HD'"><img :src="ConstData.IMG_PATH + '/gong/common/btn/btn_module_buy_01.gif'" alt="결제하기"></a>
                        <a href="javascript:void(0);" @click="singleOrderAfterPreCheck(row)"><img :src="ConstData.IMG_PATH + '/gong/common/btn/btn_module_buy_01.gif'" alt="결제하기"></a>
                    </div>
                </div>
            </li>
        </ul>

        <!-- //lecture_view::get_staca_academy_total_lecture_html Style -->
        <ul class="lecture_list academy_simple_list" v-if="output == 'simple'">
            <li v-for="row in lectureList">
                <h4 class="lec_step"><strong>{{row.category_nm}}</strong><span>[{{row.teacher_name}}]</span></h4>
                <div class="lec_section_title">
                    <ul class="live_icon_list" style="margin-top:-35px; float:right;">
                        <li v-for="liveRow in row.live_icon_list" style="padding: 5px 15px;background-color: #8041D9;color: white;">{{liveRow}}</li>
                    </ul>
                    <p><a :href="detailLink(row)">{{row.sale_name}}</a></p>
                    <span>개강일 : <strong>{{row.period_text}}</strong></span>
                    <ul class="medal_list">
                        <li v-for="imgRow in row.sale_icon_list"><img :src="imgRow"/></li>
                    </ul>
                    <div class="discount_area">
                        <div v-if="row.amt_list[0].sale_dis_rate > 0">
                            <span class="txt_original_price"><vue-numeric v-model="row.amt_list[0].sale_amt" read-only></vue-numeric>원</span>
                            <strong style="top:-35px;"><vue-numeric v-model="row.amt_list[0].display_sale_amt" read-only></vue-numeric>원</strong>
                            <span class="txt_discount">{{row.amt_list[0].sale_dis_rate}}%할인</span>
                        </div>
                    </div>
                </div>
                <div class="lec_section_subscript">
                    <div class="lec_period">
                        {{row.cole_edt}} 까지
                        <span class="end_icon" v-for="imgRow in row.close_icon_list"><img :src="imgRow"/></span>
                        <span class="end_icon" v-if="row.sale_status === 'AD'"><img :src=" ConstData.IMG_PATH + '/gong/common/btn/icon_end_add.gif'" alt="추가모집"></span>
                    </div>
                    <div class="buy_price">
                        <input type="checkbox" :id="'product_' + row.saleinfo_id" name="saleinfo_id[]" :value="row.saleinfo_id" :disabled="row.sale_status == 'HD' ? true : false" />
                        <label :for="'product_' + row.saleinfo_id">강좌</label>
                        수강료 : <span style="color:red;font-weight: bold;" v-if="row.amt_list[0].sale_dis_rate > 0">{{row.amt_list[0].sale_dis_rate}}% 할인 </span>
                        <strong><vue-numeric v-model="row.amt_list[0].display_sale_amt" read-only></vue-numeric>원</strong>
                    </div>
                    <a href="javascript:alert('마감되었습니다.');void(0);" v-if="row.sale_status === 'HD'"><img :src="ConstData.IMG_PATH + '/gong/common/btn/btn_register_end.gif'" alt="마감"></a>
                    <a href="javascript:void(0);" @click="multiFormOrder(1)" v-else-if="row.sale_status === AP"><img :src="ConstData.IMG_PATH + '/gong/common/btn/btn_register_endclose.gif'" alt="마감임박"></a>
                    <a href="javascript:void(0);" @click="multiFormOrder(1)" v-else><img :src=" ConstData.IMG_PATH + '/gong/common/btn/btn_register_dangi.gif'" alt="수강신청"></a>
                </div>
            </li>
        </ul>
    </form>
</template>

<script>
import Axios from 'axios';
import Loading from 'vue-loading-overlay';
import VueNumeric from 'vue-numeric';
import 'vue-loading-overlay/dist/vue-loading.min.css';

export default {
  name: 'staca-lecture',
  props: {
    lectureType: String, local: String, subjectId: String, teacherId: String, output: String, withSubject: String,
  },
  created() {
    if (this.withSubject === 'Y') {
      Axios.get(`/gong/academy/class_lecture/ax_get_SubjectList/${this.local}`).then((response) => {
        if (Object.prototype.hasOwnProperty.call(response.data, 'result')) {
          const responseList = response.data.result;
          if (Object.prototype.hasOwnProperty.call(responseList, 'subjectList') && responseList.subjectList.length > 0) {
            this.subjectList = responseList.subjectList;
          } else {
            this.subjectList = [];
          }
        }

      });
    }

    this.getLectureList();
  },
  data() {
    return {
      isLoading: false,
      lectureList: [],
      subjectList: [],
      selectedSubjectId: '',
      selectedTeachertId: '',
    };
  },
  methods: {
    detailLink(args) {
      let detailLink = '';
      if (args.com_cls_id == '17') {
        //const relationSaleinfoId = (Object.prototype.hasOwnProperty.call(args, 'relation_saleinfo_id')) ? args.relation_saleinfo_id : '';
        //add_single_order_after_pre_check(1, args.saleinfo_id, '/gong/academy/payment/staca_pre_pay/check_choice', args.com_cls_id, relationSaleinfoId);
        detailLink = 'javascript:void(0);';
      } else {
        detailLink = `/gong/academy/staca/product_detail/view/${args.saleinfo_id}`;
      }
      return detailLink;
    },
    selectSubject(subjectId) {
      this.getLectureList(subjectId, this.selectedTeachertId);
    },
    selectTeacher(teacherId) {
      this.getLectureList(this.selectedSubject, teacherId);
    },
    getLectureList(selSubjectId, selTeacherId) {
      const addParams = [];
      if (typeof selSubjectId !== 'undefined' && selSubjectId !== 'ALL') {
        addParams.push(`subject_id=${selSubjectId}`);
        this.selectedSubjectId = selSubjectId;
      } else if (typeof this.subjectId !== 'undefined' && this.subjectId.length > 0) {
        addParams.push(`subject_id=${this.subjectId}`);
        this.selectedSubjectId = this.subjectId;
      } else {
        this.selectedSubjectId = 'ALL';
      }

      if (typeof selTeacherId !== 'undefined' && selTeacherId !== 'ALL') {
        addParams.push(`teacher_id=${selTeacherId}`);
        this.selectedTeachertId = selTeacherId;
      } else if (typeof this.teacherId !== 'undefined' && this.teacherId.length > 0) {
        addParams.push(`teacher_id=${this.teacherId}`);
        this.selectedTeachertId = this.teacherId;
      } else {
        this.selectedTeachertId = 'ALL';
      }

      let getParams = '';
      if (addParams.length > 0) {
        getParams = `?${addParams.join('&')}`;
      }

      this.isLoading = true;
      Axios.get(`/gong/academy/class_lecture/ax_get_LectureList/${this.local}/${this.lectureType}${getParams}`).then((response) => {
        if (Object.prototype.hasOwnProperty.call(response.data, 'result')) {
          const responseList = response.data.result;
          if (response.data.result.lectureList.length > 0) {
            this.lectureList = responseList.lectureList;
          } else {
            this.lectureList = [];
          }
          this.isLoading = false;
        }
      });
    },
    afterPreCheck(args) {
      if (args.com_cls_id == '17' && args.sale_limit_status !== 'HD') {
        const relationSaleinfoId = (Object.prototype.hasOwnProperty.call(args, 'relation_saleinfo_id')) ? args.relation_saleinfo_id : '';
        add_single_order_after_pre_check(1, args.saleinfo_id, '/gong/academy/payment/staca_pre_pay/check_choice', args.com_cls_id, relationSaleinfoId);
      }
    },
    singleOrderAfterPreCheck(args) {
      const relationSaleinfoId = (Object.prototype.hasOwnProperty.call(args, 'relation_saleinfo_id')) ? args.relation_saleinfo_id : '';
      add_single_order_after_pre_check(1, args.saleinfo_id, '/gong/academy/payment/staca_pre_pay/check_choice', args.com_cls_id, relationSaleinfoId);
    },
    multiFormOrder(orderType) {
      add_multiple_order(orderType, $('#pay_form'));
    },
  },
  components: {
    Loading,
    VueNumeric,
  },
};
</script>



// WEBPACK FOOTER //
// src/Lecture/components/staca-lecture.vue